/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './dictionary-item.dto';
export * from './dictionary-item.mapper';
export * from './dictionary-rest.service';
